import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Target = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 2C8.28 2 2 8.28 2 16C2 23.72 8.28 30 16 30C23.72 30 30 23.72 30 16C30 8.28 23.72 2 16 2ZM17 27.958V25C17 24.448 16.552 24 16 24C15.448 24 15 24.448 15 25V27.958C9.179 27.475 4.524 22.821 4.042 17H7C7.552 17 8 16.552 8 16C8 15.448 7.552 15 7 15H4.042C4.524 9.179 9.179 4.525 15 4.042V7C15 7.552 15.448 8 16 8C16.552 8 17 7.552 17 7V4.042C22.821 4.524 27.476 9.179 27.958 15H25C24.448 15 24 15.448 24 16C24 16.552 24.448 17 25 17H27.958C27.475 22.821 22.821 27.476 17 27.958Z" />
		<path d="M16 12C13.794 12 12 13.794 12 16C12 18.206 13.794 20 16 20C18.206 20 20 18.206 20 16C20 13.794 18.206 12 16 12ZM16 18C14.897 18 14 17.103 14 16C14 14.897 14.897 14 16 14C17.103 14 18 14.897 18 16C18 17.103 17.103 18 16 18Z" />
	</svg>
);

export default Target;
